import * as React from 'react';
import styles from '../styles/wizards/AddMeetingItemsFromTemplateWizard.scss';
import { __, setTableParams, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import LoadFromTemplateIcon from '../assets/images/boq-load-from-template-16x16.svg';
import AddMeetingItemsFromTemplateForm from '../forms/add_meeting_items_from_template_wizard/AddMeetingItemsFromTemplateForm';
import { addMeetingItemsFromTemplate } from '../redux/actions/table/all_meetings';
import { withRouter } from 'react-router';

const AddMeetingItemsFromTemplateWizard = ({ onClose, match }) => {
  const _handleSubmit = (formData) => {
    return validateForm(
      addMeetingItemsFromTemplate(match.params.meeting, {
        meeting_template_id: formData.meeting_template_id,
      }).then(() => {
        setTableParams('all_meetings', {
          forceUpdate: true,
        });

        onClose();

        setTimeout(
          () =>
            setNotification(
              __('all_meetings.notification.selected-template-has-been-added')
            ),
          25
        );
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.add-meeting-items-template.title')}</span>
          <span>{__('wizard.add-meeting-items-template.subtitle')}</span>
        </div>
        <div className={styles.right}>
          <LoadFromTemplateIcon />
        </div>
      </div>
      <div className={styles.body}>
        <AddMeetingItemsFromTemplateForm
          onSubmit={_handleSubmit}
          onClose={onClose}
        />
      </div>
    </>
  );
};

export default withRouter(AddMeetingItemsFromTemplateWizard);
